import { render, staticRenderFns } from "./CampaignInformationVSelectDedicatedNumberOption.vue?vue&type=template&id=4c38e018&"
import script from "./CampaignInformationVSelectDedicatedNumberOption.vue?vue&type=script&lang=js&"
export * from "./CampaignInformationVSelectDedicatedNumberOption.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports